import React, { useState, useEffect } from 'react';
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import KPICards from './KPICards';
import ProductActivity from './ProductActivity';
import PlatformDistribution from './PlatformDistribution';
import SoldProducts from './SoldProducts';
import ImageProcessing from './ImageProcessing';
import LaborSavings from './LaborSavings';
import RecentActivity from './RecentActivity';
import './Dashboard.css';

const Dashboard = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate data loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="dashboard-skeleton">
          <div className="skeleton-header"></div>
          <div className="skeleton-cards">
            <div className="skeleton-card"></div>
            <div className="skeleton-card"></div>
            <div className="skeleton-card"></div>
            <div className="skeleton-card"></div>
            <div className="skeleton-card"></div>
          </div>
          <div className="skeleton-charts">
            <div className="skeleton-chart"></div>
            <div className="skeleton-chart"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="professional-dashboard">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Analytics Dashboard</h1>
        <p className="dashboard-subtitle">Monitor your product listing automation and business performance</p>
      </div>

      <MDBContainer fluid className="dashboard-content">
        {/* TOP SECTION - KPI CARDS & PLATFORM DISTRIBUTION IN SAME GRID */}
        <div className="top-grid-section">
          <div className="kpi-section">
            <KPICards />
          </div>
          <div className="platform-section">
            <PlatformDistribution />
          </div>
        </div>

        {/* PRODUCT UPLOAD ACTIVITY */}
        <MDBRow className="mb-4">
          <MDBCol lg="12">
            <ProductActivity />
          </MDBCol>
        </MDBRow>

        {/* SOLD PRODUCTS & IMAGE PROCESSING */}
        <MDBRow className="mb-4">
          <MDBCol lg="4" className="mb-4 mb-lg-0">
            <SoldProducts />
          </MDBCol>
          <MDBCol lg="8">
            <ImageProcessing />
          </MDBCol>
        </MDBRow>

        {/* LABOR SAVINGS & RECENT ACTIVITY */}
        <MDBRow className="mb-4">
          <MDBCol lg="8" className="mb-4 mb-lg-0">
            <LaborSavings />
          </MDBCol>
          <MDBCol lg="4">
            <RecentActivity />
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
  );
};

export default Dashboard;